import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-506ac098")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: "domainCard",
    style: {"height":"calc(100vh - 75px)"}
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.categoryList,
        selection: _ctx.selectedCategories,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCategories = $event)),
        selectionModifiers: { sync: true },
        class: "p-datatable-sm kn-table",
        dataKey: "categoryId",
        paginator: true,
        rows: 20,
        responsiveLayout: "stack",
        breakpoint: "960px",
        scrollable: true,
        scrollHeight: "flex",
        "data-test": "data-table"
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            class: "kn-column-checkbox",
            selectionMode: "multiple",
            dataKey: "categoryId"
          }),
          _createVNode(_component_Column, {
            field: "categoryName",
            header: _ctx.$t('common.name'),
            style: _ctx.domainCategoryTabDescriptor.column.header.style
          }, null, 8, ["header", "style"])
        ]),
        _: 1
      }, 8, ["value", "selection"])
    ]),
    _: 1
  }))
})